import { IconOverflow, Box, ButtonIcon } from 'braid-design-system';
import type { KeyboardEvent } from 'react';

interface TriggerProps {
  isActive: boolean;
  label: string;
  onClick?: () => void;
  onKeyDown?: (event: KeyboardEvent<HTMLButtonElement>) => void;
  triggerRef?: React.RefObject<HTMLButtonElement> | null;
}

export const Trigger = ({
  isActive,
  label,
  onClick,
  onKeyDown,
  triggerRef,
}: TriggerProps) => (
  <Box display="flex" justifyContent="flexEnd">
    <ButtonIcon
      id="dropdown-trigger"
      data={{ testid: 'dropdown-trigger' }}
      icon={<IconOverflow />}
      variant="transparent"
      label={label}
      ref={triggerRef}
      onClick={onClick}
      onKeyDown={onKeyDown}
      aria-haspopup={isActive}
      aria-expanded={isActive}
      tabIndex={0}
    />
  </Box>
);
